export default {
    // Module RP
    LISTE_PARTIES: 'LISTE_PARTIES',
    LOBBY: 'LOBBY',
    NOT_A_PLAYER: 'NOT_A_PLAYER',
    NEW_GAME: 'NEW_GAME',
    NEW_GAME_NAME_USED: 'NEW_GAME_NAME_USED',
    LOAD_GAME: 'LOAD_GAME',
    CONFIGURE: 'CONFIGURE',
    DELETE_GAME: 'DELETE_GAME',
    NOT_ADMIN: 'NOT_ADMIN',
    CONFIGURE_UPDATE: 'CONFIGURE_UPDATE',
    NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
    NOTIFICATION_ERROR: 'NOTIFICATION_ERROR',
    REQUEST_JOIN_GAME: 'REQUEST_JOIN_GAME',
    CANCEL_REQUEST_JOIN_GAME: 'CANCEL_REQUEST_JOIN_GAME',
    ACCEPT_NEW_PLAYER: 'ACCEPT_NEW_PLAYER',
    REFUSE_NEW_PLAYER: 'REFUSE_NEW_PLAYER',
    MANAGE_PLAYER: 'MANAGE_PLAYER',
    DELETE_PLAYER: 'DELETE_PLAYER',
    EDIT_PLAYER: 'EDIT_PLAYER',
    NEW_BUILDING: 'NEW_BUILDING',
    MANAGE_BUILDING: 'MANAGE_BUILDING',
    EDIT_BUILDING: 'EDIT_BUILDING',
    DELETE_BUILDING: 'DELETE_BUILDING',
    ADD_VEHICLE_IN_BUILDING: 'ADD_VEHICLE_IN_BUILDING',
    EDIT_VEHICLE_IN_BUILDING: 'EDIT_VEHICLE_IN_BUILDING',
    DELETE_VEHICLE_IN_BUILDING: 'DELETE_VEHICLE_IN_BUILDING',
    NEW_VEHICLE_MODEL: 'NEW_VEHICLE_MODEL',
    MANAGE_VEHICLE_MODEL: 'MANAGE_VEHICLE_MODEL',
    EDIT_VEHICLE_MODEL: 'EDIT_VEHICLE_MODEL',
    DELETE_VEHICLE_MODEL: 'DELETE_VEHICLE_MODEL',
    NEW_SKILL: 'NEW_SKILL',
    MANAGE_SKILL: 'MANANGE_SKILL',
    EDIT_SKILL: 'EDIT_SKILL',
    DELETE_SKILL: 'DELETE_SKILL',
    MANAGE_RANK: 'MANAGE_RANK',
    NEW_RANK: 'NEW_RANK',
    DELETE_RANK: 'DELETE_RANK',
    EDIT_RANK: 'EDIT_RANK',
    NEW_STATUS: 'NEW_STATUS',
    MANAGE_STATUS: 'MANAGE_STATUS',
    DELETE_STATUS: 'DELETE_STATUS',
    EDIT_STATUS: 'EDIT_STATUS',
    NEW_SERVICE: 'NEW_SERVICE',
    MANAGE_SERVICE: 'MANAGE_SERVICE',
    EDIT_SERVICE: 'EDIT_SERVICE',
    DELETE_SERVICE: 'DELETE_SERVICE',
    MANAGE_FUNCTION: 'MANAGE_FUNCTION',
    EDIT_FUNCTION: 'EDIT_FUNCTION',
    NEW_FUNCTION: 'NEW_FUNCTION',
    DELETE_FUNCTION: 'DELETE_FUNCTION',
    SIG_MAP: 'SIG_MAP',
    SIG_ADD_DEPARTMENT: 'SIG_ADD_DEPARTMENT',
    SIG_REMOVE_DEPARTMENT: 'SIG_REMOVE_DEPARTMENT',
    // Init Socket
    PING: 'PING',
    CONNECT_ERROR: 'connect_error',
    // Vérification session
    TEST_SESSION: 'site:001:00',
    SESSION_OK: 'site:000:00',
    SESSION_INVALID: 'site:000:01',
    // Connexion nouvelle session
    CONNEXION: 'site:001:03',
    CONNEXION_OK: 'site:001:01',
    INFOS_SESSION_INVALID: 'site:001:02',
    BANNED_ACCUNT: 'site:sanctions:banni',
    ACTIVATION_NEEDED: 'site:002:01',
    // Mot de passe oublié
    FORGOT_PWD: 'site:001:08',
    FORGOT_PWD_MAIL_SEND: 'site:001:10',
    FORGOT_PWD_USERNAME_UNKNOW: 'site:001:09',
    // Inscription
    INSCRIPTION: 'site:001:05',
    INSCRIPTION_USERNAME_USED: 'site:001:06',
    INSCRIPTION_MAIL_USED: 'site:001:11',
    INSCRIPTION_CODE_INVALID: 'site:001:12',
    INSCRIPTION_OK: 'site:001:07',
    // Administration
    IS_ADMIN: 'IS_ADMIN',
    // Boutique
    SHOP: 'SHOP',
    BUY_OPTION: 'BUY_OPTION',
    // Assignments
    ASSIGNMENTS: 'ASSIGNMENTS',
    UPDATE_PLANNING: 'UPDATE_PLANNING',
    DELETE_PLANNING: 'DELETE_PLANNING',
    // Incidents
    ADD_INCIDENT: 'ADD_INCIDENT',
    EDIT_INCIDENT: 'EDIT_INCIDENT',
    DELETE_INCIDENT: 'DELETE_INCIDENT',
    GET_INCIDENT: 'GET_INCIDENT',
    // SGA
    SGA: 'SGA',
    NEW_ALERT: 'NEW_ALERT',
    // SGO
    SGO: 'SGO',
    ADD_LOGBOOK: 'ADD_LOGBOOK',
    CLOSE_MISSION: 'CLOSE_MISSION',
    SELECT: 'SELECT',
    ADD_TO_START: 'ADD_TO_START',
    ENGAGE: 'ENGAGE',
    CHANGE_STATUS_VEHICLE: 'CHANGE_STATUS_VEHICLE',
    REMOVE_VEHICLE_MISSION: 'REMOVE_VEHICLE_MISSION',
    UPDATE_MANNING: 'UPDATE_MANNING',
    SEND_MESSAGE_TO_VEHICLE: 'SEND_MESSAGE_TO_VEHICLE',
    ACKNOWLEDGE_NOTIFICATION: 'ACKNOWLEDGE_NOTIFICATION',
    FAILURE_ENGAGEMENT: 'FAILURE_ENGAGEMENT',
    // BIP
    BIP_ON: 'BIP_ON',
    BIP_MESSAGE: 'BIP_MESSAGE',
    BIP_ALERT: 'BIP_ALERT',
    // RADIO
    RADIO_ON: 'RADIO_ON',
    RADIO_SEND_STATUS: 'RADIO_SEND_STATUS',
    RADIO_MESSAGE: 'RADIO_MESSAGE',
    // TICKET DE DEPART
    IMP_TICKET: 'IMP_TICKET',
};
